<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('SignIn')"
    :closeText="$t('Close')"
    maxWidth="655px"
  >
    <v-row>
      <v-col>
        <h3>1) {{ $t('DownloadFuturaeApp') }}</h3>
        <h3>2) {{ $t('ScanQrCode') }}</h3>
        <h3>3) {{ $t('SignIn') }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <iframe :src="futuraeActivationQRCodeURL" style="width: 605px;height: 605px;"></iframe>
      </v-col>
    </v-row>
  </base-modal>
</template>
<script>

export default {
    name: 'TwoFactorAuthenticationEnrollModal',
    data() {
        return {
            modal: {
                title: this.$t('TwoFactorAuthentication'),
                key: 'twoFactorAuthenticationEnrollModal',
            },
            open: false,
            futuraeActivationQRCodeURL: '',
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
    },
    methods: {
        saveItem() {
            this.$emit('on-two-factor-authentication-enroll');
            this.hide();
        },
        new(futuraeActivationQRCodeURL) {
            this.futuraeActivationQRCodeURL = futuraeActivationQRCodeURL;
            this.show();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
